import {
  isIndependentUser,
  isMember,
  isProvider,
  type RoleProfile,
} from '@shared/rbac/member-roles'

/**
 * Primary navigation gating.
 *
 * Sessions is visible to provider staff (all levels L2/L3/L4 — Basic, Admin,
 * Owner) AND service-recipient members: providers get their schedule with
 * check-in/out and voice notes; members get a read-only view of their own
 * sessions (timeline, provider contact, live en-route map — the server's
 * `list-my-sessions` member branch). Independent users and unknown/missing
 * roles stay hidden and are redirected off the `/sessions` route (see
 * `RequireSessionsAccess` in `App.tsx`) — a missing profile fails CLOSED.
 *
 * Exception: an Independent who FOLLOWS at least one member's sessions (the
 * server's per-association session-follow, `followsSessions`) sees Sessions as
 * a read-only follower.
 *
 * Callers pass the freshest role profile they have (auth user seed, refined by
 * the `me` profile — see `useSessionsNavVisible`).
 */
export function isSessionsNavVisibleFor(
  profile: RoleProfile | null | undefined,
  opts: { followsSessions?: boolean } = {},
): boolean {
  if (!profile) return false
  if (isIndependentUser(profile)) return opts.followsSessions === true
  return isProvider(profile) || isMember(profile)
}
